import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesService {

  constructor(
    private http: HttpClient
  ) { }

  apiUrl = environment.HOST;

  getSalesOptions(){
    return this.http.get(this.apiUrl + "/api/sales/list-names");
  }

  getInfoSaleKind(idSale){
    return this.http.get(this.apiUrl + "/api/sales/detail/" + idSale );
  }

  sendSaleKind(file: FormData){
    return this.http.post(this.apiUrl + "/api/sales/save", file);
  }

  getSaleKindVersions(page){
    return this.http.get(this.apiUrl + `/api/sales/list?page=${page - 1}&size=10`);
  }

}
